import { connect } from 'react-redux';

import { FeaturesLayout, IFeaturesLayoutStateProps } from './FeaturesLayout';
import { IState } from '../../../store';

export function mapStateToProps(state: IState): IFeaturesLayoutStateProps {
  return {
    featureList: state.villageData.village.featureList ?? [],
    isHidden: state.isFatCard,
  };
}

export const FeaturesLayoutContainer = connect<IFeaturesLayoutStateProps>(mapStateToProps)(FeaturesLayout);
